import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from "react-router-dom";
import Navbar from './components/Navbar';
import { getWebClient, getDataTablesLanguage } from '../helpers/Helpers.js';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';

export default function DateOre() {

    DataTable.use(DT);

    const navigate = useNavigate();

    const columns = [
        { data: 'dataTestuale', type: 'string', orderable: false },
        { data: 'progressivo', type: 'string', orderable: false },
        { data: 'oraDa', type: 'string', orderable: false },
        { data: 'oraA', type: 'string', orderable: false },
        {
            orderable: false,
            width: '87px',
            data: 'id',
        }
    ];

    const options = {
        language: getDataTablesLanguage()
    };

    const [tableData, setTableData] = useState([]);  

    function handleDetailsClick(data) {
        navigate(`/dateore/${data}`);
    }

    useEffect(() => {

        const client = getWebClient();

        client.get(`/api/dateore`)
            .then(function (response) {
                setTableData(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

    }, []);

    return (
        <>

            <link href="https://cdn.datatables.net/v/bs5/dt-2.1.8/datatables.min.css" rel="stylesheet"></link>

            <Navbar />

            <div className="container" style={{ marginTop: 40, marginBottom: 40 }} >
                <div className="row">
                    <div className="col">
                        <h4>Date/ore</h4>
                    </div>
                    <div className="col text-end">
                        <a href="/dateore/new" style={{ position: 'relative', top: 7 }} onClick={(ev) => { ev.preventDefault(); navigate("/dateore/new") }}>Crea nuova data/ora</a>
                    </div>
                </div>
            </div>

            <div className="container" style={{ marginBottom: 80 }}>
                <DataTable data={tableData} columns={columns} options={options} className="table"
                    slots={{
                        4: (data, row) => (
                            <a href={`dateore/${data}`} onClick={(ev) => { ev.preventDefault(); handleDetailsClick(data) }}>Dettagli</a>
                        )
                    }}
                >
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Progressivo</th>
                            <th>Ora inizio</th>
                            <th>Ora fine</th>
                            <th></th>
                        </tr>
                    </thead>
                </DataTable>
            </div>

        </>
    )
}
